/**
 * SUPERADMIN may edit/delete any activity master row.
 * School users (e.g. SCHOOLE) may only change rows that belong to their school.
 * Rows with no schooleId are global / admin master data.
 */
export function canEditDeleteActivityRow(row) {
  let userDetails = {};
  try {
    userDetails = JSON.parse(localStorage.getItem("userDetail") || "{}");
  } catch (e) {
    return false;
  }
  if (userDetails.role === "SUPERADMIN") return true;

  const rowSchool = row?.schooleId?._id ?? row?.schooleId;
  const userSchool =
    userDetails.schooleId?._id ??
    userDetails.schooleId ??
    userDetails.schoolId?._id ??
    userDetails.schoolId;
  if (rowSchool == null || rowSchool === "" || userSchool == null || userSchool === "") {
    return false;
  }
  return String(rowSchool) === String(userSchool);
}
